import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { getMappedEstimatedExposureData } from "mappers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { EstimatedExposureDto, ErrorResponse } from "types";

type useGetEstimatedExposureQueryProps = {
	creditReviewId: string;
};

const useGetEstimatedExposureQuery = ({
	creditReviewId,
}: useGetEstimatedExposureQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["executiveEstimatedExposureInfo", creditReviewId],
		() =>
			creditReviewDetailsService.getEstimatedExposureInfo({
				creditReviewId,
			}),
		{
			select: (data: EstimatedExposureDto) => {
				return getMappedEstimatedExposureData(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!creditReviewId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetEstimatedExposureQuery;
